import React from 'react';
import { Navbar, Footer } from '@/features/layout';
import { HeroSection } from '@/features/home/HeroSection';
import { CredentialsSection } from '@/features/contact/CredentialsSection';
import { StructuredData } from '@/seo';

export default function App() {
  return (
    <>
      <StructuredData />
      <div className="min-h-screen bg-paper text-ink">
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-brand focus:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2"
        >
          Skip to main content
        </a>
        <header aria-label="Site header">
          <Navbar />
        </header>

        <main id="main-content" role="main">
          <HeroSection />
          <CredentialsSection />
        </main>

        <Footer />
      </div>
    </>
  );
}
